import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlServidor } from '../util/url-servidor';
import { Observable } from 'rxjs';
import { PageResponse } from '../api/dto/paginacao/page-response';
import { FluxoSaidaCaixa } from '../api/dto/fluxo-saida-caixa';

@Injectable({
  providedIn: 'root'
})
export class GerenciarSaidaCaixaService {

  private url : string = UrlServidor.URL_BASE + 'gerenciar-saidas-caixa';

  constructor(private http: HttpClient) { }

  listar(pagina?: number, tamanho?: number, ordenacao?: string): Observable<PageResponse<FluxoSaidaCaixa>> {

    let parametros = new HttpParams();
    if (pagina) {
      parametros = parametros.set('page', pagina);
    }
    if (tamanho) {
      parametros = parametros.set('size', tamanho);
    }
    if (ordenacao) {
        parametros = parametros.set('sort', ordenacao);
    }
    
    return this.http.get<PageResponse<FluxoSaidaCaixa>>(this.url, {params: parametros});
  }

  processar(saidaCaixaReq: any): Observable<void> {
    return this.http.post<void>(`${this.url}/processar`, saidaCaixaReq);
  }
}
